import RedirectHelper from '../../../components/RedirectHelper';

const Registration = (): JSX.Element => {
  RedirectHelper.redirectToUserManagement('/register');
  return <></>;
};

export default Registration;
